import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";

import { StyledSingleSelectDDItem } from "../../dropdown/styles";

export const StyledItemText = styled.span`
    ${mixins.setFontVariant("input2", colorsPalettes.carbon["500"])};
    margin-left: 8px;
`;

export const StyledDropdownItem = styled(StyledSingleSelectDDItem)<{ disabled?: boolean; iconStroke?: string }>`
    background-color: ${colorsPalettes.carbon["0"]};
    justify-content: flex-start;
    padding: 10px 16px;

    & ${SWReactIcons} {
        flex: none;
        svg path {
            fill: ${colorsPalettes.carbon["200"]};
            fill-opacity: 1;
            ${({ iconStroke }) =>
                iconStroke
                    ? css`
                          stroke: ${iconStroke};
                      `
                    : ""};
        }
    }

    &:hover {
        background-color: ${colorsPalettes.carbon["25"]};
    }

    ${StyledItemText} {
        opacity: ${({ disabled }) => (disabled ? 0.5 : "inherit")};
    }
`;

export const StyledLockedIconContainer = styled.div`
    margin-left: auto;
`;
